"use client";
import { jsxs as o, jsx as l } from "react/jsx-runtime";
const i = ({
  title: c,
  titleId: a,
  desc: r,
  descId: t,
  ...e
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": a,
    "aria-describedby": t,
    ...e,
    children: [
      r ? /* @__PURE__ */ l("desc", { id: t, children: r }) : null,
      c ? /* @__PURE__ */ l("title", { id: a, children: c }) : null,
      /* @__PURE__ */ l(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.2,
          d: "M3.058 26.433h21.164a2.16 2.16 0 0 0 2.159-2.158V3.061C26.435 1.893 25.437.9 24.275.9H3.058C1.895.9.9 1.895.9 3.058v21.217c0 1.164.995 2.158 2.158 2.158Zm22.12-2.158a.902.902 0 0 1-.903.903H3.058c-.472 0-.902-.43-.902-.903V6.905h23.022zM2.156 3.058c0-.472.43-.902.902-.902h21.164c.529 0 .956.433.956.902V5.65H2.156z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.2,
          d: "M7.88 19.367v.003a1.14 1.14 0 0 0 .174 1.334l.95.95c.35.35.927.407 1.334.175l.003-.002.635-.39c.202.113.43.2.634.278l.126.05.197.689c.118.467.58.813 1.047.813h1.372c.522 0 .93-.349 1.047-.813l.196-.687c.278-.094.52-.192.761-.33l.634.39a.99.99 0 0 0 .582.173c.287 0 .577-.114.756-.293l.95-.95c.352-.351.405-.874.178-1.33l-.003-.004-.394-.689c.114-.203.202-.431.28-.636l.05-.126.69-.197c.466-.118.812-.58.812-1.047v-1.372c0-.523-.35-.93-.814-1.047l-.742-.198-.049-.125c-.078-.204-.165-.432-.279-.634l.391-.635.002-.003a1.141 1.141 0 0 0-.174-1.334l-.95-.95a1.141 1.141 0 0 0-1.335-.175l-.002.002-.635.39a4.2 4.2 0 0 0-.762-.33l-.196-.687a1.114 1.114 0 0 0-1.047-.813h-1.372c-.522 0-.93.349-1.046.813l-.197.687c-.278.094-.52.192-.761.33l-.635-.39-.003-.002a1.141 1.141 0 0 0-1.334.175l-.95.95c-.351.35-.405.874-.177 1.329l.004.008.391.635c-.114.202-.201.43-.279.634l-.049.126-.69.197c-.467.118-.813.58-.813 1.047v1.383c.058.513.401.919.866 1.036l.69.197.049.126c.078.204.165.432.279.634l-.391.635Zm.483-4.073.004-.002c.34-.113.634-.345.75-.753h.001l.002-.008c.05-.247.148-.446.304-.707l.004-.007c.17-.34.177-.75-.06-1.051l-.327-.56.785-.785.565.376v.001l.01.006c.341.17.746.175 1.044-.002.205-.102.462-.205.725-.31.345-.117.631-.403.746-.749l.002-.004.19-.667h1.116l.19.667.002.004c.113.34.343.632.748.75.079.03.162.059.241.086l.146.05c.122.046.23.095.325.165l.007.006.008.004c.34.17.752.177 1.054-.062l.561-.374.784.783-.381.62v-.001l-.005.008a1.109 1.109 0 0 0-.002 1.035c.053.133.106.252.159.369.052.119.104.235.156.364.116.345.402.631.748.746l.004.002.666.19V16.6l-.666.19-.004.002c-.34.113-.634.345-.75.753h-.001l-.002.008c-.049.247-.148.446-.304.707l-.004.007c-.17.34-.177.752.062 1.053l.374.562-.785.785-.672-.384a1.072 1.072 0 0 0-1.1-.002c-.206.103-.463.206-.726.312a1.207 1.207 0 0 0-.747.748l-.003.008-.001.01-.093.652h-1.105l-.19-.666-.002-.004c-.113-.34-.345-.634-.753-.75v-.001l-.008-.002c-.247-.049-.446-.148-.707-.304l-.007-.004a1.218 1.218 0 0 0-1.092 0l-.01.007-.564.375-.734-.78.382-.62.005-.009c.171-.343.172-.692.002-1.035a11 11 0 0 0-.158-.369c-.053-.119-.105-.235-.156-.364a1.207 1.207 0 0 0-.749-.746l-.004-.002-.666-.19v-1.063z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.2,
          d: "M24.639 3.903v-.009l-.002-.008a.762.762 0 0 0-.221-.439.655.655 0 0 0-.458-.172H11.925c-.181 0-.34.06-.453.174a.627.627 0 0 0-.175.454c0 .18.061.34.175.453a.627.627 0 0 0 .453.175h12.086c.181 0 .34-.061.454-.175a.628.628 0 0 0 .174-.453ZM13.667 19.836a3.772 3.772 0 0 0 3.794-3.794 3.772 3.772 0 0 0-3.794-3.795 3.772 3.772 0 0 0-3.795 3.795 3.772 3.772 0 0 0 3.795 3.794Zm0-6.333a2.513 2.513 0 0 1 2.539 2.539 2.513 2.513 0 0 1-2.54 2.539 2.513 2.513 0 0 1-2.538-2.54 2.513 2.513 0 0 1 2.539-2.538ZM3.463 3.463a.61.61 0 0 0 0 .88c.25.25.63.25.88 0a.61.61 0 0 0 .005-.875.53.53 0 0 0-.425-.193.655.655 0 0 0-.46.188Zm2.586 0a.61.61 0 0 0 0 .88c.25.25.63.25.88 0a.61.61 0 0 0 .005-.875.53.53 0 0 0-.425-.193.655.655 0 0 0-.46.188Zm2.586 0a.61.61 0 0 0 0 .88c.25.25.63.25.88 0a.61.61 0 0 0 .005-.875.53.53 0 0 0-.425-.193.655.655 0 0 0-.46.188Z"
        }
      )
    ]
  }
);
export {
  i as default
};
